import React from 'react';
import classNames from 'classnames';
import s from './style.scss';
const Tag = ({ style, text, active, onClick }) => {
    return (React.createElement("div", { className: classNames(s.tag, style, { [s.active]: active }), onClick: onClick }, text));
};
export default Tag;
